import React, { createContext, useCallback, useContext, useState } from "react";
import DoxPreview from "@/components/DoxPreview";

const DoxPreviewContext = createContext(null);

/**
 * Global provider for Dox Preview\u2122 — the one-question-at-a-time,
 * Apple-calm experience where the customer watches Dox handle a renewal
 * end-to-end before trusting him with a real filing.
 *
 * Any component can call `openDoxPreview()` to launch the experience.
 */
export function DoxPreviewProvider({ children }) {
  const [open, setOpen] = useState(false);

  const openDoxPreview = useCallback(() => setOpen(true), []);
  const closeDoxPreview = useCallback(() => setOpen(false), []);

  return (
    <DoxPreviewContext.Provider value={{ openDoxPreview, closeDoxPreview }}>
      {children}
      <DoxPreview open={open} onClose={closeDoxPreview} />
    </DoxPreviewContext.Provider>
  );
}

export function useDoxPreview() {
  const ctx = useContext(DoxPreviewContext);
  // Graceful degradation for consumers rendered outside the provider (e.g.
  // the public marketing site). Widget checks `available` before offering
  // the preview affordance.
  if (!ctx) return { openDoxPreview: null, closeDoxPreview: null, available: false };
  return { ...ctx, available: true };
}
